export const GET_USERS = page => `https://boosters.pro/api/champ/rating?champname=alfabattle2&tasknumber=${page}`;
